import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ContactPage from "./pages/ContactPage";
import SurveyPage from "./pages/SurveyPage";
import SurveyResultPage from "./pages/SurveyResultPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import ServicesPage from "./pages/ServicesPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import "./App.css";

function Layout({ children, hideHeaderFooter }) {
  return (
    <>
      {!hideHeaderFooter && <Header />}
      <div className="main-content">{children}</div>
      {!hideHeaderFooter && <Footer />}
      <ScrollToTop />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout><HomePage /></Layout>} />
        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
        <Route path="/survey" element={<Layout><ProtectedRoute><SurveyPage /></ProtectedRoute></Layout>} />
        <Route path="/survey/results/:id" element={<Layout hideHeaderFooter><ProtectedRoute><SurveyResultPage /></ProtectedRoute></Layout>} />
        <Route path="/services" element={<Layout hideHeaderFooter><ProtectedRoute><ServicesPage /></ProtectedRoute></Layout>} />
        <Route path="/login" element={<Layout hideHeaderFooter><LoginPage /></Layout>} />
        <Route path="/change-password" element={<Layout hideHeaderFooter><ProtectedRoute><ChangePasswordPage /></ProtectedRoute></Layout>} />
        <Route path="/dashboard" element={<Layout hideHeaderFooter><ProtectedRoute><DashboardPage /></ProtectedRoute></Layout>} />
        <Route path="/admin/users" element={<Layout hideHeaderFooter><ProtectedRoute adminOnly><AdminUsersPage /></ProtectedRoute></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}
